import { render, staticRenderFns } from "./subject-select.vue?vue&type=template&id=373b0fa0&scoped=true&"
import script from "./subject-select.vue?vue&type=script&lang=js&"
export * from "./subject-select.vue?vue&type=script&lang=js&"
import style0 from "./subject-select.vue?vue&type=style&index=0&id=373b0fa0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373b0fa0",
  null
  
)

export default component.exports